export default "__VITE_ASSET__5Mc3Q6Pm__"